import { ARM_METHODS } from "./hikvisionControl";
import { OptionCard, StepBody, StepHeader, StepNav } from "./HikvisionWizardParts";

// Only shown when the user chose not to use zones.
const HikvisionStepArmMethod = ({ armMethod, setArmMethod, hasOutputs, onNext, onBack, isLastStep }) => (
    <>
        <StepHeader title="How do you want to arm/disarm?" />
        <StepBody>
            <OptionCard
                radio
                title="Pick rules/inputs to control"
                subtitle="Arm and disarm selected Hikvision rules/inputs"
                selected={armMethod === ARM_METHODS.RULES}
                onClick={() => setArmMethod(ARM_METHODS.RULES)}
            />
            <OptionCard
                radio
                title="Pick hikvision output(s) to control"
                subtitle={hasOutputs ? "Control One Key Disarm by wiring an output to input 1" : "No alarm outputs were found on this Hikvision"}
                selected={armMethod === ARM_METHODS.ONE_KEY}
                disabled={!hasOutputs}
                onClick={() => setArmMethod(ARM_METHODS.ONE_KEY)}
            />
        </StepBody>
        <StepNav
            onBack={onBack}
            onNext={onNext}
            nextDisabled={armMethod == null}
            nextLabel={isLastStep ? "Link Hikvision" : "Next"}
            nextIcon={isLastStep ? "pi pi-link" : "pi pi-arrow-right"}
        />
    </>
);

export default HikvisionStepArmMethod;
